import React, { useCallback } from 'react';
import { updateLine } from 'actions/livefeed'
import { Rnd } from 'react-rnd';
import { RndStyle } from './RndStyle'
import update from 'immutability-helper';
import { getPosition, handleSetCurrentEntity } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
/*
Special rule for using react-rnd
If the entity has padding and border: for example padding 5, border 1
then onDragStop or onResizeStop will return x,y and width include padding + border
So,if the padding and border for are added for editor view only,
the actual value need to be calculated. ( minos 6 for x,y and minos 12 for width)
But the position value props and size set on react-rnd component need to plus 6 for x,y and 12 for width from state,.
*/

const LineContainer = ({ editorView, scaleMode, dispatch, stepNumberState, slideCurrentIndex, livefeedSlides }) => {

    const { lineState, historyEntities } = livefeedSlides[slideCurrentIndex];
    let history = historyEntities.slice();
    let currentEntity = history[stepNumberState];

    const isLineShown = lineState.show ? true : false;
    const enableResizing = {
        bottom: isLineShown,
        bottomLeft: false,
        bottomRight: false,
        left: isLineShown,
        right: isLineShown,
        top: isLineShown,
        topLeft: false,
        topRight: false
    }
    const setLinePos = useCallback((newPosition) => {
        let { x, y } = newPosition;
        // prevent duplicate dispatch
        if (lineState.left !== x || lineState.top !== y) {
            // Don't mutate it :)
            const newLine = update(lineState, {
                top: { $set: y },
                left: { $set: x },
                align: { $set: "" },
                activeToolbarItems: { [0]: { align: { $set: "" } } }
            });

            dispatch(updateLine(newLine))
        }
    }, [dispatch, lineState])

    const setLineSize = useCallback((length, thickness, newPosition) => {
        let { x, y } = newPosition;
        let align = `${lineState.left === x ? `${lineState.activeToolbarItems[0].align}` : ""}`
        // prevent duplicate dispatch
        if (lineState.length !== length || lineState.thickness !== thickness || lineState.left !== newPosition.x) {
            const newLine = update(lineState, {
                length: { $set: length },
                thickness: { $set: thickness },
                top: { $set: y },
                left: { $set: x },
                align: { $set: align },
                activeToolbarItems: {
                    [0]: {
                        align: {
                            $set: align
                        }
                    }
                }
            });
            dispatch(updateLine(newLine))
        }
    }, [dispatch, lineState])

    const handleSetCurrentEntityCallback = useCallback(() => {
        handleSetCurrentEntity(currentEntity, lineState, dispatch)
    }, [currentEntity, dispatch, lineState])
    return (
        <React.Fragment>
            {isLineShown ?
                editorView && !scaleMode ?
                    <Rnd
                        bounds={".livefeed-preview-wrapper"}
                        data-tooltip={`${isLineShown && 'Click on the edge and drag to resize \n Click and drag to the desired position'}\n Current length ${lineState.length}px\n Current thickness ${lineState.thickness}px`}
                        enableResizing={enableResizing}
                        className={`entity-resizable  ${currentEntity.id === 'line' ? 'entity-active' : ''} `}
                        lockAspectRatio={false}
                        resizeHandleWrapperClass={"resizers"}
                        resizeHandleStyles={{
                            left: RndStyle.left, right: RndStyle.right,
                            top: RndStyle.top, bottom: RndStyle.bottom
                        }}
                        //  width need lineState.length to be plus 12 due to padding 5 and border 1
                        size={{ width: lineState.length + 12, height: "auto" }}
                        position={{ x: lineState.left - 6, y: lineState.top - 6 }}// minus padding+border
                        onDragStart={() => handleSetCurrentEntityCallback()}
                        onDragStop={(e, d) => setLinePos(getPosition(d))}
                        onResizeStart={() => handleSetCurrentEntityCallback()}
                        onResizeStop={(e, direction, ref, delta, position) =>
                            position.x !== 0 && setLineSize(ref.offsetWidth - 12, ref.offsetHeight - 12, getPosition(position))}
                    >
                        <div className={`line-wrapper`} >
                            <div className={"line"}
                                style={{
                                    width: lineState.length, height: lineState.thickness + "px",
                                    backgroundColor: lineState.color, top: lineState.top + "px",
                                    left: lineState.left + "px"
                                }} />
                        </div>
                    </Rnd>
                    :
                    <div
                        style={{
                            padding: 5, position: "absolute", width: lineState.length * (scaleMode ? 0.375 : 1) + 12, height: "auto",
                            pointerEvents: "none", transform: `translate(${lineState.left * (scaleMode ? 0.375 : 1) - 6}px, ${lineState.top * (scaleMode ? 0.375 : 1) - 6}px)`
                        }}
                        className={`entity-resizable editor-view_false`}
                    >
                        <div className={`line-wrapper`} >
                            <div className={"line"}
                                style={{
                                    width: lineState.length, height: lineState.thickness + "px",
                                    backgroundColor: lineState.color, top: lineState.top * (scaleMode ? 0.375 : 1) + "px",
                                    left: lineState.left * (scaleMode ? 0.375 : 1) + "px"
                                }} />
                        </div>
                    </div>
                :
                null
            }
        </React.Fragment>
    );
}
export default LineContainer;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/entity/LineContainer.jsx